<div *ngIf="!securedProductFlag && false" class="container">
  <div
    class="col-lg-6 col-lg-push-3 col-md-8 col-md-push-2 col-sm-10 col-sm-push-1 col-xs-12 terms-section text-center smallText">
    <p>
      By proceeding, I agree to the <a id="link_Terms_Condition" class="hand-cursor" (click)="OpenPopup($event)"> Terms &amp; Conditions, </a>
      <a class="hand-cursor" href="https://www.bajajfinservmarkets.in/legal-and-compliance.html" target="_blank">Terms
        of Use, </a>
      <a class="hand-cursor" href="https://www.bajajfinservmarkets.in/legal-and-compliance.html#parentHorizontalTab3"
        target="_blank"> Privacy Policy</a> and hereby authorize Bajaj Finserv representatives to Call / SMS for this
      application / Bajaj Finserv RBL Bank SuperCard and other products/services. This consent will override any registration by me for DNC/NDNC.
    </p>
  </div>

  <div class="col-xs-12 bottom-spc-20">
    <h2 class="col-md-12 col-sm-12 col-xs-12 text-center heading h2-title">Instant Loans in India</h2>
    <div
      class="col-lg-6 col-lg-push-3 col-md-8 col-md-push-2 col-sm-10 col-sm-push-1 col-xs-12 text-center top-margin-10 p-Loan-sub-text-font">
      Be it a trip to your dream destination, renovating your home with modern furnishing, wedding planning or dealing with a medical emergency, You need not even worry about expanding your business or finances for your new venture. Finserv Markets is here to help.
      <p class="top-margin-10 bold">Apply for an instant loan today and enjoy life king-size.</p>
    </div>
  </div>
  <div class="col-xs-12">
    <div class="bold-divider-line bottom-spc-20 clearfix"></div>
  </div>
  <div class="col-xs-12 bottom-spc-20 need-card-heading">
    <h2 class="col-md-12 col-sm-12 col-xs-12 text-center heading h2-title">Loan Requirements with Finserv MARKETS</h2>
  </div>
  <div class="col-lg-10 col-lg-push-1 col-md-10 col-md-push-1 col-sm-12 col-xs-12 bottom-pad-50 no-gutter-xs-only">
    <div class="col-md-6 col-sm-6 col-xs-12 need-card-section">
      <div class="need-card">
        <div class="text-center need-card-title"><img src="./assets/img/svg/Revised_icons_Interest_rate.svg" />
          Interest rate and charges
        </div>
        <div class="need-card-subtext-padding">
          <div class="need-subtext-line">Avail loan of any amount upto <span class="bold">25 lacs</span></div>
        </div>
        <div class="need-card-subtext-padding">
          <div class="need-subtext-line">Affordable rate of interest starts at <span class="bold">13.00% p.a</span>
          </div>
        </div>
        <div class="need-card-subtext-padding">
          <div class="need-subtext-line">Other charges : Processing fee <span class="bold">2% + GST</span>
            <p>Convenience charges <span class="bold">4999</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 need-card-section">
      <div class="need-card">
        <div class="text-center need-card-title"><img src="./assets/img/svg/Revised_icons_Document.svg" />
          Documents required
        </div>
        <div class="need-card-subtext-padding">
          <div class="need-subtext-line bold">Aadhaar Card/Passport/Driving License</div>
        </div>
        <div class="need-card-subtext-padding">
          <div class="need-subtext-line bold">PAN card</div>
        </div>
        <div class="need-card-subtext-padding">
          <div class="need-subtext-line bottom-pad-60">Last three months <span class="bold">Bank Account
              Statement</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!securedProductFlag" class="container-fluid left-rigth-pad-0 bottom-pad-30">
  <div class="col-xs-12 bg-grey howItWorksSection sub-content bottom-pad-40">
    <h2 class="text-center heading h2-title">How it Works?</h2>
    <div class="top-pad-20 loanSection clearfix">
      <div class="col-lg-12 col-xs-12 col-md-12">
        <div class="col-lg-8 col-md-10 col-sm-12 loanBlock left-rigth-pad-0 clearfix">
          <div class="col-xs-12 col-md-6 col-sm-6 left-rigth-pad-0">
            <div class="loanInfo clearfix">
              <h1 class="mobile-content-number">01</h1>
              <div>
                <h2 class="bold">Check Eligibility</h2>
                <h4>Know your eligibility by giving us a few details</h4>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 col-sm-6 lastChild left-rigth-pad-0">
            <div class="loanInfo clearfix">
              <h1 class="mobile-content-number">02</h1>
              <div>
                <h2 class="bold">Customise your Loan</h2>
                <h4>Choose the right product to bundle your product.</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 col-md-12">
        <div class="col-lg-8 col-md-10 col-sm-12 loanBlock no-borderBtm left-rigth-pad-0 clearfix">
          <div class="col-xs-12 col-md-6 col-sm-6 left-rigth-pad-0">
            <div class="loanInfo clearfix">
              <h1 class="mobile-content-number">03</h1>
              <div>
                <h2 class="bold">Verify Me</h2>
                <h4>Get verified with our secured online processes</h4>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-xs-12 col-md-6 col-sm-6 lastChild left-rigth-pad-0">
            <div class="loanInfo clearfix">
              <h1 class="mobile-content-number">04</h1>
              <div>
                <h2 class="bold">Money in Account</h2>
                <h4>Loan will be instantly transferred to your bank account</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!securedProductFlag" class="container">
  <div class="col-xs-12 top-margin-10 bottom-pad-50">
    <h2 class="col-md-12 col-sm-12 col-xs-12 text-center heading h2-title bottom-margin-20">What is a Hybrid Flexi
      Personal Loan?</h2>
    <div class="col-lg-8 col-lg-push-2 col-md-10 col-md-push-1 col-sm-12 col-xs-12 text-center p-Loan-sub-text-font">
      <p class="bold">Need an urgent personal loan but worried about repayment the next moment?</p>
      We present you Hybrid Flexi Personal Loan - the new way to fund your dreams. Enjoy principal holiday tenure,
      flexible part-payments and unlimited withdrawals! Find out more about our Hybrid Flexi Personal Loan and how you
      can
      benefit from it, right here.
    </div>
  </div>
</div>
<div *ngIf="!securedProductFlag" class="container-fluid scrollmenu-block bottom-pad-50">
  <div class="flexi-scrollmenu">
    <div class="flexi-scroll-container clearfix">
      <div class="flexi-card flexi-border-marin">
        <div class="flexi-card-Head bottom-pad-5">Interest Only <br />EMI</div>
        <div class="flexi-sub-text">As an exclusive benefit, during the initial period of your Hybrid Flexi Personal
          Loan,
          you need to pay only the interest amount as the EMI.</div>
      </div>
      <div class="flexi-card flexi-border-yellow ">
        <div class="flexi-card-Head bottom-pad-5">No Additional Charges </div>
        <div class="flexi-sub-text">Even if you choose to make part-payments for your principal amount, you will not
          incur
          any hidden charges.</div>
      </div>
      <div class="flexi-card flexi-border-aqua ">
        <div class="flexi-card-Head bottom-pad-5">Flexi-Repayment </div>
        <div class="flexi-sub-text">You have complete flexibility and control of your principal amount. You can also
          login
          to the customer portal and choose to make part-payments.</div>
      </div>
      <div class="flexi-card flexi-border-blue ">
        <div class="flexi-card-Head bottom-pad-5">Unlimited Withdrawals</div>
        <div class="flexi-sub-text">With this Bajaj Finserv Personal Loan, you can withdraw without limit for, as many
          times you need.</div>
      </div>
      <div class="flexi-card flexi-border-pink ">
        <div class="flexi-card-Head bottom-pad-5">No Repeated Form Filling</div>
        <div class="flexi-sub-text">You need not fill forms for each requirement. You can just withdraw money from your
          Personal loan limit anywhere 24X7.</div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="securedProductFlag" class="col-xs-12 sub-content bottom-pad-50">
    <h1 class="text-center heading">Money in your bank account in 4 steps</h1>
    <div class="divider-line"></div>
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10 sub-images">
        <div class="row">
          <div class="col-lg-3">
            <div class="baja-spec-figure">
              <img src="./assets/img/svg/quickapproval.svg" alt="Login" />
            </div>
            <h3>Get Approval</h3>
            <figcaption>Quick check to know suitable offers</figcaption>
            <div class="divider-line cust-width div-line-marg-top"></div>
          </div>
          <div class="col-lg-3">
            <div class="baja-spec-figure">
              <img src="./assets/img/svg/geteligibility.svg" alt="Login" />
            </div>  
            <div>
              <h3>Get Property Assessed</h3>
              <figcaption>Know your eligibility by giving us your property details.</figcaption>
            </div>
            <div class="divider-line cust-width div-line-marg-top"></div>
          </div>
          <div class="col-lg-3">
            <div class="baja-spec-figure">
              <img src="./assets/img/svg/loanrequirement.svg" alt="Login" />
            </div>
            <div>
              <h3>Customize Your Loan</h3>
              <figcaption>Choose the right product to bundle your product</figcaption>
            </div>
            <div class="divider-line cust-width div-line-marg-top"></div>
          </div>
          <div class="col-lg-3">
            <div class="baja-spec-figure">
              <img src="./assets/img/svg/verifyme.svg" alt="Login" />
            </div>
            <h3>Verify Self</h3>
            <figcaption class="sub-heading-description">Get verified with our secured online process</figcaption>
            <div class="divider-line cust-width"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- <div class="col-xs-12 bottom-pad-50">
  <h1 class="text-center heading">Money in your bank account in 4 steps</h1>
  <div class="divider-line"></div>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-10 sub-images">
      <div class="row">
        <div *ngIf="securedProductFlag" class="col-lg-3">
          <div class="baja-spec-figure">
            <img src="./assets/img/svg/quickapproval.svg" alt="Login" />
          </div>
          <h3>Get Approval</h3>
          <figcaption>Quick check to know suitable offers</figcaption>
          <div class="divider-line cust-width div-line-marg-top"></div>
        </div>
        <div class="col-lg-3">
          <div class="baja-spec-figure">
            <img src="./assets/img/svg/geteligibility.svg" alt="Login" />
          </div>
          <div *ngIf="!securedProductFlag">
            <h3>Check Eligibility</h3>
            <figcaption>Know your eligibility by giving us a few details.</figcaption>
          </div>

          <div *ngIf="securedProductFlag">
            <h3>Get Property Assessed</h3>
            <figcaption>Know your eligibility by giving us your property details.</figcaption>
          </div>
          <div class="divider-line cust-width div-line-marg-top"></div>
        </div>
        <div class="col-lg-3">
          <div class="baja-spec-figure">
            <img src="./assets/img/svg/loanrequirement.svg" alt="Login" />
          </div>
          <div *ngIf="!securedProductFlag">
            <h3>Customize your Loan</h3>
            <figcaption>Choose the right product for you </figcaption>
          </div>
          <div *ngIf="securedProductFlag">
            <h3>Customize Your Loan</h3>
            <figcaption>Choose the right product to bundle your product</figcaption>
          </div>
          <div class="divider-line cust-width div-line-marg-top"></div>
        </div>
        <div class="col-lg-3">
          <div class="baja-spec-figure">
            <img src="./assets/img/svg/verifyme.svg" alt="Login" />
          </div>
          <h3 *ngIf="!securedProductFlag">Verify Yourself</h3>
          <h3 *ngIf="securedProductFlag">Verify Self</h3>
          <figcaption class="sub-heading-description">Get verified with our secured online process</figcaption>
          <div class="divider-line cust-width"></div>
        </div>
        <div class="col-lg-3" *ngIf="!securedProductFlag">
          <div class="baja-spec-figure">
            <img src="./assets/img/svg/bank_account.svg" alt="Login" />
          </div>
          <h3 *ngIf="!securedProductFlag">Money in Account</h3>
          <figcaption>Post verification, loan will be instantly transferred to your bank account</figcaption>
          <div class="divider-line cust-width div-line-marg-top"></div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<div *ngIf="securedProductFlag" class="container text-center terms-section-link bottom-spc-20">
    <p>
      By proceeding, I agree to the 
        <a id="link_Terms_Condition" class="hand-cursor" (click)="OpenPopup($event)"> Terms &amp; Conditions, </a>
      <a class="hand-cursor" href="https://www.bajajfinservmarkets.in/legal-and-compliance.html" target="_blank">Terms
        of Use, </a>
      <a class="hand-cursor" href="https://www.bajajfinservmarkets.in/legal-and-compliance.html#parentHorizontalTab3"
        target="_blank"> Privacy Policy</a> and hereby authorize Bajaj Finserv representatives to Call / SMS for this
      application and other products/services. This consent will override any registration by me for DNC/NDNC.
    </p>
  </div>
<!-- Terms & Conditions Modal need to remove from this page -->
<custom-popup [config]="Config" [title]="'Terms and Conditions'" [showClose]="true" [subtitle]="''" [id]="'termsModal'">
  <!--     <div class="modal-body"> -->
  <div id="dynamicContent" class="modal-body termsConditionDescription">
      <ol class="termsConditionList">
          <li class="bottom-pad-30">
              <span class="terms"></span>
              <span>I declare that all the particulars and information provided by me in this application form are
                  true, correct,
                  complete and up-to-date in all respects and that I have not withheld any information whatsoever.</span>
          </li>
          <li class="bottom-pad-30">
              <span class="terms"></span>
              <span>I confirm that I have/had no insolvency proceedings against me nor have I ever been adjudicated
                  insolvent by
                  any court or other authority and I further confirm that I have read the information on various loan
                  products
                  made available by {{CompanyName}} Limited (hereinafter referred to as “{{CompanyName}}”) on the Website
                  <a href="https://www.bajajfinserv.in/finance" target="_blank">www.bajajfinserv.in/finance</a></span>
          </li>
          <li class="bottom-pad-30">
              <span class="terms"></span>
              <span>I authorize {{CompanyName}} to exchange, share all information and details as provided by me in my
                  application
                  and in relation to my existing loans and/or repayment history to any third party including but not
                  limited
                  to its group companies, service providers, banks, financial institutions, credit bureaus,
                  telecommunication
                  companies, statutory bodies, etc. for customer verification, personalization of products or
                  services, credit
                  rating, data enrichment, marketing or promotion of {{CompanyName}} services or related products or
                  that of
                  its associates and affiliates or for enforcement of your obligations and I shall not hold {{CompanyName}} (or
                  any of its group companies or its/their agents/representatives) liable for the use/sharing of the
                  information
                  as stated above.</span>
          </li>
          <li class="bottom-pad-30">
              <span class="terms"></span>
              <span>I agree and affirm that {{CompanyName}} may contact me and communicate with me over telephonic
                  calls, or SMS on
                  the mobile number mentioned in the application, or through any other communication mode
                  (“Communication Modes”)
                  to verify the details provided by me on the application. Further, I confirm that I would like to
                  know through
                  the above mentioned Communication Modes various {{CompanyName}} loan offer schemes or loan
                  promotional schemes
                  or any other promotional schemes relating to various products/services offered by BFL/its group
                  companies
                  from time to time and hereby authorize BFL, its group companies, employees, agents, associates to
                  contact
                  me from time to time for the same.
              </span></li>
          <li class="bottom-pad-30">
              <span class="terms"></span><span>I agree and confirm that laws in relation to the unsolicited
                  communication referred to in the “National Do Not
                  Call Registry” (the “NDNC Registry”) as laid down by the Telecom Regulatory Authority of India will
                  not be
                  applicable for such communication/calls/ SMSs received from BFL, its group companies, its
                  employees, agents
                  and/or associates.</span></li>
          <li class="bottom-pad-30"><span class="terms"></span><span>I undertake to keep {{CompanyName}} updated of any
                  change in the information provided by me in this application
                  form.</span></li>
          <li class="bottom-pad-30"><span class="terms"></span><span>I understand and acknowledge that {{CompanyName}}
                  shall have the absolute discretion, without assigning any reason
                  to reject my loan application and that {{CompanyName}} shall not be responsible/liable in any manner
                  whatsoever
                  for such rejection.</span>
          </li>
      </ol>
      <p>I further understand and agree that pursuant to this application form, I will be required to submit documents to
          the satisfaction of {{CompanyName}} and accept the loan terms and conditions for availing the loan granted to
          me by {{CompanyName}} from time to time.</p>
      <p class="bottom-pad-50">
          <button type="button" class="close_custom_popup btn btn-block col-md-6 col-md-offset-5 col-sm-6 col-sm-offset-5 col-xs-6 col-xs-offset-4 bottom-pad-30"
              id="close_custom_popup" (click)="ClosePopup($event);PushDataLayerValues($event.currentTarget.id);">Close</button>
      </p>
  </div>
</custom-popup>